
    <piece [pieces]="smartPieces$ | async" [taskLinksOnly]="taskLinksOnly" (smartTaskLinkUpdated)="onSmartTaskLinkUpdated()"></piece>